import React from "react";

const OrderDetails = () => {
  return (
    <div className="order-page container-fluid" style={{marginTop:"115px"}}>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb">
        Home &gt; My Account &gt; My Orders &gt; <span>OD43636930323848100</span>
      </div> */}

      <div className="row">
        {/* LEFT SECTION */}
        <div className="col-lg-8">
          <div className="card order-card">
            <div className="order-top">
              <p>Pay online for a smooth doorstep experience</p>
              <button className="pay-btn">Pay ₹216</button>
            </div>

            <div className="product-info">
              <div>
                <h5>
                  SINGHTECH AW950 RGB GAMING MOUSE Wired Ambidextrous
                  Optical Gaming Mouse
                </h5>
                <p className="text-muted">Black</p>
                <p className="seller">Seller: SANWALIYATRADERS</p>
                <h4>₹216</h4>
              </div>

              <img
                src="https://rukminim2.flixcart.com/image/312/312/xif0q/mouse/h/x/z/aw950-singhtech-original-imaghhgzfd8rmjxe.jpeg"
                alt="product"
              />
            </div>

            {/* ORDER TRACKING */}
            <div className="tracking">
              <div className="track active">
                <span></span>
                <p>
                  <strong>Order Confirmed, Today</strong>
                  <br />
                  Your Order has been placed, Sat 27th Dec
                </p>
              </div>

              <div className="track">
                <span></span>
                <p>Shipped, Expected by Dec 30</p>
              </div>

              <div className="track">
                <span></span>
                <p>Out For Delivery</p>
              </div>

              <div className="track">
                <span></span>
                <p>Delivery, Jan 02, 2026 by 11 PM</p>
              </div>
            </div>

            <a href="#" className="see-updates">
              See All Updates →
            </a>

            <div className="order-actions">
              <button className="btn-outline">Cancel</button>
              <button className="btn-outline">Chat with us</button>
            </div>
          </div>

          <div className="card simple-card">
            <p>Rate your experience</p>
          </div>

          <div className="card simple-card">
            <p>Send Order Details</p>
          </div>
        </div>

        {/* RIGHT SECTION */}
        <div className="col-lg-4">
          <div className="card side-card">
            <h6>Delivery details</h6>
            <p>
              <strong>Home</strong>
              <br />
              Annapurna daily needs Gadge nagar, Near ...
            </p>
            <p>
              <strong>Prajwal Punatkar</strong>
              <br />
              9325996893
            </p>
          </div>

          <div className="card side-card">
            <h6>Price details</h6>

            <div className="price-row">
              <span>Listing price</span>
              <span className="strike">₹500</span>
            </div>

            <div className="price-row">
              <span>Selling price</span>
              <span>₹200</span>
            </div>

            <div className="price-row">
              <span>Total fee</span>
              <span>₹16</span>
            </div>

            <hr />

            <div className="price-row total">
              <span>Total amount</span>
              <span>₹216</span>
            </div>

            <p className="payment">
              Payment method <strong>Cash On Delivery</strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;